import store from 'store2'

import post from '../../../lib/post'

export default function(roll,start,deleteStart,filter){

  var ombStore = store.namespace('omb')

  post(
    'data',
    {
      token: ombStore('token'),
      type: 'thumbAntiArchive',
      roll: roll,
      start: start,
      deleteStart: deleteStart,
      filter: filter,
    },
    function(){
      console.log('thumb generated',roll,start,filter)
    }
  )

}



// WEBPACK FOOTER //
// ./src/client/view/admin/lib/generateThumbAntiArchive.js